export const VSS_COMMUNICATION_EVENTS = {
  // 供货规则切换事件 父->子
  VSS_HEADER_SUPPLIER_CHANGE: "supplierIdChange",

  // 供货规则选择器是否展示和禁用 子->父
  VSS_HEADER_SUPPLIER_SELECT: "supplierSelect",

  IFRAME_EVENT: {
    TOOLS_LINK_TO: "$tools-linkTo",
  },
};
